import { Link } from "react-router-dom";

interface Entry {
  type: string;
  label: string;
  desc: string;
  icon: string;
  accent: string;
  iconBg: string;
}

const entries: Entry[] = [
  {
    type: "movie",
    label: "电影",
    desc: "科幻 · 悬疑 · 爱情 · 历史",
    icon: "ri-film-line",
    accent: "text-primary-700",
    iconBg: "bg-primary-100 text-primary-700",
  },
  {
    type: "tv",
    label: "电视剧",
    desc: "都市 · 刑侦 · 奇幻 · 年代",
    icon: "ri-tv-2-line",
    accent: "text-secondary-700",
    iconBg: "bg-secondary-100 text-secondary-700",
  },
  {
    type: "variety",
    label: "综艺",
    desc: "竞技 · 美食 · 音乐 · 推理",
    icon: "ri-mic-line",
    accent: "text-accent-700",
    iconBg: "bg-accent-100 text-accent-700",
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {entries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group flex items-center gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span
            className={`w-14 h-14 flex items-center justify-center rounded-lg ${entry.iconBg}`}
          >
            <i className={`${entry.icon} text-2xl`}></i>
          </span>
          <div className="min-w-0">
            <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
              {entry.label}频道
            </h3>
            <p className="mt-0.5 text-sm text-foreground-500 truncate">{entry.desc}</p>
          </div>
          <i className="ri-arrow-right-line ml-auto text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
        </Link>
      ))}
    </div>
  );
}